import logo from "../images/logo.svg";
import React from "react";
import {makeStyles} from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import HTTPClient from "../HTTPClient";

import config from "../config.json";
import {getMessage} from "../util";

const useStyles = makeStyles(theme => ({
        paper: {
            marginTop: theme.spacing(4),
            marginBottom: theme.spacing(2),
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        },
        logo: {
            width: '100%',
            height: 'auto',
            maxWidth: '200px',
            display: 'block'
        },
        logo_small: {
            width: '20px',
            float: 'right'
        },
        number: {
            fontFamily: "Montserrat"
        }

    }
));


const Header = (props) => {
    const classes = useStyles();

    const logout = () => {

        HTTPClient({
            method: "get",
            url:
                process.env.REACT_APP_API_URL +
                "/logout/"+ props.meeting.slug
        })
            .then(() => {
                localStorage.removeItem('evoting-front-user');
                window.location = '/login';

            })
            .catch(error => {
                console.log('cannot logout', error);
                alert(getMessage(props.meeting.meeting_type,'cannot_close_session',props.messages));
            })

    };

    const total = Object.keys(props.user.shares).map(k => {
        if (props.meeting.shares[k].attendance) {
            return (props.meeting.shares[k].rights * props.user.shares[k].shares);
        } else {
            return(0);
        }
    }).reduce((acc, elem) => {
        return (acc + elem);
    }, 0)

    return (


        <Grid item xs={12} className={classes.paper}>
            <Grid container>
                <Grid item xs={12} sm={4}>
                    <img src={props.logo ? props.logo : logo} alt="logo" className={classes.logo}/>
                </Grid>
                <Grid item xs={8} sm={5}>
                    <Typography>
                        {props.user.data.run} {props.user.data.name} {props.user.custodian && <span>{getMessage(props.meeting.meeting_type,'is_custodian',props.messages)}</span>}<br/>
                    </Typography>


                            <Typography variant="h5" >{getMessage(props.meeting.meeting_type,'total_shares',props.messages)}: <span className={classes.number} >{total.toLocaleString(navigator.language, {
                                maximumFractionDigits: config.precision, minimumFractionDigits: 0
                            })} </span>
                            </Typography>
                            {(props.meeting.shares[Object.keys(props.meeting.shares)[0]].rights !== 1 || Object.keys(props.meeting.shares).length > 1) && Object.keys(props.user.shares).length > 0 && Object.keys(props.user.shares).map(k => (
                                    <span
                                        key={k} > {props.user.shares[k].name}: <span className={classes.number}>{props.user.shares[k].shares.toLocaleString(navigator.language, {
                                        maximumFractionDigits: config.precision
                                    })}</span></span>
                                ))}



                </Grid>
                <Grid item xs={4} sm={2} align="right">

                    {(props.meeting && props.meeting.state !== 'open') && (
                        <Button variant="outlined" onClick={logout}>{getMessage(props.meeting.meeting_type,'logout',props.messages)}</Button>
                    )}

                </Grid>

            </Grid>

        </Grid>

    );
};

export default Header;
